import { AddressCard } from "./AddressCard";

export default AddressCard;